import sliceCreator from '../../index.jsx';
import {TENANT_LOGIN} from '../../../constants/index.jsx';
const _tenantLoginAction = sliceCreator('TENANT_LOGIN', TENANT_LOGIN, 'post');

const { asyncAction: tenantLoginAction, reducer, clearData: clearTenantLoginAction } = _tenantLoginAction;

export default reducer;

export {
    tenantLoginAction,
    clearTenantLoginAction
}